export default __webpack_public_path__ + "static/media/sidebar-bg.410b9eb6.png";